// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gxh5S1BiXU0oaVPCKsgC{margin-left:6px;padding:0 58px;overflow-x:hidden;overflow-y:auto}.gxh5S1BiXU0oaVPCKsgC .ls41TD6vv0YMKmBdu8oB{padding:0 18px}.eGh0HBqBh44qRKIsS2rj{flex-direction:column;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `gxh5S1BiXU0oaVPCKsgC`,
	"tabs": `ls41TD6vv0YMKmBdu8oB`,
	"integrationPageHeader": `eGh0HBqBh44qRKIsS2rj`
};
export default ___CSS_LOADER_EXPORT___;
